import axios from 'axios';
import Notification from '../notification/notification-es';

const popup = Notification({
    position: 'top-right',
    duration: 2000,
    isHidePrev: false,
    isHideTitle: true,
    maxOpened: 3,
});

const dataPrefix = 'data-main-sign-up';
const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    mainSignUp();
}

export function mainSignUp() {
    initInputAnimation();
    initFormSubmission();
}

function initInputAnimation() {
    const form = document.querySelector('[data-main-sign-up-form]');
    const input = document.querySelector('[data-main-sign-up-form-input]');

    if (!form || !input) return;

    input.addEventListener('focus', () => {
        form.classList.add('active');
    });

    input.addEventListener('blur', () => {
        if (!input.value.trim()) {
            form.classList.remove('active');
        }
    });
}

function initFormSubmission() {
    const form = document.querySelector('[data-main-sign-up-form]');
    const input = document.querySelector('[data-main-sign-up-form-input]');
    const submitBtn = document.querySelector('[data-main-sign-up-form-submit]');

    if (!form || !input || !submitBtn) return;

    // Настраиваем CSRF-токен для axios
    const tokenMeta = document.head.querySelector('meta[name="csrf-token"]');
    if (tokenMeta) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = tokenMeta.content;
    } else {
        console.warn('CSRF token not found: add <meta name="csrf-token" content="{{ csrf_token() }}">');
    }

    submitBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const emailValue = input.value.trim();
        if (!emailValue) {
            popup.error({ message: 'Введіть, будь ласка, електронну пошту.' });
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(emailValue)) {
            popup.error({ message: 'Неправильний формат Email.' });
            return;
        }

        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.classList.add('loading');

        axios.post('/subscribe', { email: emailValue })
            .then(response => {
                if (response.data && response.data.status === 'success') {
                    popup.success({ message: response.data.message || 'Ви успішно підписалися!' });
                    input.value = '';
                    form.classList.remove('active');
                } else {
                    popup.error({ message: 'Не вдалося підписатися. Спробуйте ще раз' });
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 422) {
                    const errors = error.response.data.errors || ['Помилка валідації'];
                    popup.error({ message: errors.join('\n') });
                } else {
                    popup.error({ message: 'Серверна помилка Спробуйте пізніше' });
                }
            })
            .finally(() => {
                submitBtn.removeAttribute('disabled');
                submitBtn.classList.remove('loading');
            });
    });
}
